import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import HowItWorksSection from "../components/HowItWorksSection";
import { Reveal } from "../theme/animation";
import HeroSection from "../theme/HeroSection";
import HomePageBody from "./HomePageBody";

const HERO_IMAGE = "/images/Boys+Basketball.png";

const HomeSmsp: React.FC = () => {
    const scrollToRoles = () => {
        const element = document.getElementById("select-your-role");
        if (element) element.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <Box>
            <HeroSection imageUrl={HERO_IMAGE} minHeight="80vh" showWave={true} animateHero>
                <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
                    <Box sx={{ maxWidth: 640 }}>
                        <Reveal variant="fadeUp" trigger="mount">
                            <Typography
                                variant="h3"
                                component="h1"
                                sx={{
                                    color: "white",
                                    fontWeight: "bold",
                                    mb: 2,
                                    fontSize: { xs: "1.75rem", sm: "2rem", md: "2.25rem" }
                                }}
                            >
                                The platform that helps people help people become their best.<small>™</small>
                            </Typography>
                        </Reveal>
                        <Reveal variant="fadeUp" trigger="mount">
                            <Typography variant="h6" component="h2" style={{ color: '#fff' }}>
                                Strong Mind Strong Performance is a human development platform designed to support growth through reflection, relationships, and practical skill-building.
                                <br />
                                Our evidence-based system helps transform anxiety into confidence and turns everyday observations into data-informed, human-centered pathways for growth.
                            </Typography>
                        </Reveal>
                        <Reveal variant="fadeUp" trigger="mount">
                            <Button
                                variant="contained"
                                size="large"
                                onClick={scrollToRoles}
                                data-attr="home-smsp_explore-path"
                                endIcon={<ChevronRightIcon />}
                                sx={{
                                    px: 3,
                                    py: 1.5,
                                    mt: 2,
                                    fontWeight: "bold",
                                    fontSize: "1rem"
                                }}
                            >
                                Explore your path
                            </Button>
                        </Reveal>
                    </Box>
                </Container>
            </HeroSection>
            <HowItWorksSection />
            <HomePageBody />
        </Box>
    );
};

export default HomeSmsp;
